import React from 'react';

// Material
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
// Project
import AuthLayout, { BRAND_BLUE, AUTH_FONTS } from 'modules/main/Login2/components/AuthLayout';

function MailForm(props) {
  const { controls, onChangeText, onSubmit, state } = props;
  const history = useHistory();

  const disabledButton = !state.email;

  return (
    <AuthLayout
      title="Recuperar contraseña"
      subtitle="Te enviaremos un enlace a tu correo para restablecerla."
      onBack={() => history.goBack()}>
      <TextField
        label="Correo electrónico"
        type="email"
        id="email"
        variant="outlined"
        value={state.email}
        onChange={onChangeText}
        fullWidth
        InputProps={{ sx: { fontSize: AUTH_FONTS.field } }}
        InputLabelProps={{ sx: { fontSize: AUTH_FONTS.field } }}
      />

      {controls.error ? (
        <Typography sx={{ color: '#e11', fontSize: AUTH_FONTS.link, textAlign: 'center' }}>
          {controls.error}
        </Typography>
      ) : null}

      <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={onSubmit}
        disabled={controls.loading || disabledButton}
        sx={{
          mt: 1,
          textTransform: 'none',
          borderRadius: 2,
          backgroundColor: BRAND_BLUE,
          ':hover': { backgroundColor: '#013a73' },
        }}>
        {controls.loading ? (
          <CircularProgress size={28} sx={{ color: '#fff' }} />
        ) : (
          <Typography sx={{ color: '#fff', fontSize: AUTH_FONTS.button, fontWeight: 600 }}>
            Recuperar contraseña
          </Typography>
        )}
      </Button>

      <Box sx={{ textAlign: 'center' }}>
        <Typography
          onClick={() => history.push('/login')}
          sx={{ color: BRAND_BLUE, fontSize: AUTH_FONTS.link, fontWeight: 600, cursor: 'pointer' }}>
          Volver a iniciar sesión
        </Typography>
      </Box>
    </AuthLayout>
  );
}

export default MailForm;
